<div class="shipping-settings-container" [formGroup]="shippingForm" *ngIf="shippingForm">
  <div class="shipping-toggle mb-4">
    <div class="flex align-items-center justify-content-between">
      <label class="font-medium">Enable Shipping</label>
      <p-inputSwitch 
        formControlName="shippingEnabled"
        (onChange)="onToggleShipping()">
      </p-inputSwitch>
    </div>
  </div>

  <div *ngIf="shippingEnabled" class="shipping-options">
    <div class="mb-3">
      <label class="block mb-2 font-medium">Shipping Rate Type</label>
      <p-dropdown 
        [options]="rateTypes"
        optionLabel="label"
        optionValue="value"
        formControlName="rateType"
        placeholder="Select rate type">
      </p-dropdown>
    </div>

    <div class="mb-3">
      <label class="block mb-2 font-medium">Shipping Cost</label>
      <p-inputNumber
        formControlName="shippingCost"
        mode="currency"
        currency="USD"
        locale="en-US"
        placeholder="Enter shipping cost">
      </p-inputNumber>
    </div>

    <p-button 
      label="Save Shipping Settings" 
      (onClick)="onSubmit()"
      styleClass="p-button-primary w-full">
    </p-button>
  </div>
</div>
